var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageButtonVk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    fill: "#0593F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    stroke: "#00041A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.52 14.52C12 17.064 12 21.132 12 29.28V30.72C12 38.856 12 42.924 14.52 45.48C17.064 48 21.132 48 29.28 48H30.72C38.856 48 42.924 48 45.48 45.48C48 42.936 48 38.868 48 30.72V29.28C48 21.144 48 17.076 45.48 14.52C42.936 12 38.868 12 30.72 12H29.28C21.144 12 17.076 12 14.52 14.52ZM18.072 22.956H22.2C22.332 29.82 25.356 32.724 27.756 33.324V22.956H31.632V28.872C33.996 28.62 36.492 25.92 37.332 22.944H41.196C40.8811 24.4846 40.2517 25.9436 39.3474 27.2299C38.443 28.5163 37.2831 29.6023 35.94 30.42C37.4389 31.1657 38.7625 32.2209 39.8237 33.5157C40.8848 34.8106 41.6593 36.3158 42.096 37.932H37.836C36.924 35.088 34.644 32.88 31.632 32.58V37.932H31.152C22.944 37.932 18.264 32.316 18.072 22.956Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageButtonVk);
export default __webpack_public_path__ + "static/media/message-button-vk.684ea3417a443afa8cf21b5f332a4b7b.svg";
export { ForwardRef as ReactComponent };